import {Dispatch} from 'redux';
import {BEEscenicArticle} from '../../../API/types';
import {beEscenicArticleToTeaserArticle} from '../../../API/utils';
import {getTeaserArticles as APIgetTeaserArticles} from '../../../API/teaserArticles';
import {TeaserArticle} from '../../../utils/types';
import standardizeError from '../../../utils/standardizeError';
import {
  TEASER_ARTICLES_GET_INVALIDATE,
  TEASER_ARTICLES_GET_REQUEST,
  TEASER_ARTICLES_GET_RESPONSE,
} from '../../actionTypes';
import {
  TeaserArticlesGetInvalidateAction,
  TeaserArticlesGetRequestAction,
  TeaserArticlesGetResponseAction,
} from '../types';

/**
 * Action creator for the get request of the sport events by date
 */
const getTeaserArticlesGetRequest = (): TeaserArticlesGetRequestAction => ({
  type: TEASER_ARTICLES_GET_REQUEST,
});

/**
 * Action creator for the request response of the sport events by date
 */
const getTeaserArticlesGetResponse = (data: TeaserArticle[]): TeaserArticlesGetResponseAction => ({
  type: TEASER_ARTICLES_GET_RESPONSE,
  payload: {data},
});

/**
 * Action creator for the request invalidate of the sport events by date
 * @param error
 */
const getTeaserArticlesGetInvalidate = (error: Error): TeaserArticlesGetInvalidateAction => ({
  type: TEASER_ARTICLES_GET_INVALIDATE,
  error: standardizeError(error),
});

/**
 * // TODO: document
 */
const getTeaserArticles = () => (dispatch: Dispatch): Promise<any> => {
  dispatch(getTeaserArticlesGetRequest());

  return APIgetTeaserArticles()
    .then((data: BEEscenicArticle[]) => data.map(beEscenicArticleToTeaserArticle))
    .then((articles: TeaserArticle[]) => dispatch(getTeaserArticlesGetResponse(articles)))
    .catch((error: Error) => dispatch(getTeaserArticlesGetInvalidate(error)));
};

export default getTeaserArticles;
